import React from "react";
import "./About.css";
import img from "../../img/islamic-studies.png";
const About = () => {
  return (
    <div>
      <div className="about-text text-white">
        <h1>
          Learn Islamic Studies at <br /> Ahsanul Uloom Madrasha
        </h1>
        <h6>
          The structure of the Islamic Studies. Islamic studies is a field of
          study which dedicated to the comprehensive study of Islam in an
          academic <br /> manner by both Muslim as well as non-Muslim scholars
          as a Religion, Worldview and Civilization, which includes the study of
          its scriptures (Qur'an), <br /> philosophy, jurisprudence and Muslims
          societies throughout history. It also includes all the traditional
          forms of religious thought such as Tafsir (Quranic exegesis), <br />
          Hadith (Traditions of the Prophet), Kalaam (Islamic philosophy), Fiqh
          (Islamic jurisprudence), Tasawwuf (Sufism), Muslim philosophy, history
          of Islam and Muslims.
        </h6>
      </div>
      <div className="about-img">
        <img src={img} alt="" />
      </div>
    </div>
  );
};

export default About;
